import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { User } from '../../store/entities/models/user.model';
import { UserProfileResponse } from '../../store/entities/models/user-profile.model';

export interface MeResponse {
  data: User;
}

export interface ProfileResponse {
  data: UserProfileResponse;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private httpService = inject(HttpService);

  getMe(): Observable<MeResponse> {
    return this.httpService.get<MeResponse>('/me');
  }

  getProfile(): Observable<ProfileResponse> {
    return this.httpService.get<ProfileResponse>('/profile');
  }
}

